module.exports = __webpack_public_path__ + "static/media/Portada_ios.92858231.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Portada_ios.png
// module id = 72
// module chunks = 1